module.exports = "\n  <input class=\"alg-checkbox\"\n  [id]=\"idInput\"\n  [name]=\"name\"\n  type=\"checkbox\"\n  (change)=\"onChange($event)\"\n  (blur)=\"onBlur($event)\"\n  [disabled]=\"disabled\"\n  [checked]=\"checked\"\n  (click)=\"onClick($event)\">\n  <label [for]=\"idInput\">{{label}}</label>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-checkbox-2/alg-checkbox-2.component.html
// module id = ./src/app/components/atoms/alg-checkbox-2/alg-checkbox-2.component.html
// module chunks = main